<p-dialog [(visible)]="display" [closable]="false" id="mu-location" class="mu-modal">
  <div class="p-grid p-justify-center">
    <div class="p-col-12 mu-without-padding mu-country-icon"><i class="fas fa-globe" aria-hidden="true"></i></div>
    <h1 class="p-col-12 mu-country-title" [innerHTML]="'common.location.title' | translate"></h1>
    <div class="p-col-12 mu-country-item" *ngFor="let item of enviromentCountries" (click)="setCountry(item)">
      <div class="mu-country-img"><img src="{{ item.ico }}" alt="{{ item.geoName }}" /></div>
      <span translate>common.location.country.{{ item.geoName }}</span>
    </div>
  </div>
</p-dialog>
